import { render } from "./App.vue?vue&type=template&id=62444745"
const script = {}

import "./App.vue?vue&type=style&index=0&id=62444745&lang=scss"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__